import { COLORS } from "../../../common/constants";

const styles = {
  authInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "&.Mui-focused fieldset": {
        borderColor: COLORS.primary,
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: "14px",
      "&.Mui-focused": {
        color: COLORS.primary,
      },
    },
    "& input": {
      fontSize: "14px",
    },
    "& fieldset": {
      "& legend": {
        fontSize: "10.5px",
      },
    },
  },
};

export default styles;
